/* Enhance accessibility around Warehouse's native menu state and actions. */
(() => {
 'use strict';
 const states=new WeakMap();
 const desktop=matchMedia('(min-width:1000px)');
 function initialize(root){
  root.querySelectorAll('[data-es-header]').forEach(header=>{
   if(states.has(header))return;
   const searchCleanup=()=>{};
   const menu=header.querySelector('.mobile-menu');
   const toggle=header.querySelector('.header__mobile-nav-toggle');
   if(!menu||!toggle){states.set(header,searchCleanup);return;}
   const panels=[...menu.querySelectorAll('.mobile-menu__panel')];
   let opened=false,active=panels[0],background=[];
   const position=()=>header.style.setProperty('--es-menu-top',Math.max(0,header.querySelector('.header').getBoundingClientRect().bottom)+'px');
   const visible=node=>node.getClientRects().length&&getComputedStyle(node).visibility!=='hidden'&&!node.closest('[inert]');
   function sync(){
    const next=menu.getAttribute('aria-hidden')==='false';
    header.classList.toggle('es-menu-open',next);
    toggle.setAttribute('aria-label',next?header.dataset.menuCloseLabel:header.dataset.menuOpenLabel);
    const nextPanel=next?panels.filter(p=>p.classList.contains('is-open')).pop()||panels[0]:null;
    panels.forEach(p=>{p.inert=p!==nextPanel;p.setAttribute('aria-hidden',p===nextPanel?'false':'true');});
    if(next&&!opened){
     background=[...document.querySelectorAll('main,.shopify-section-group-footer-group')].map(n=>[n,n.inert]);
     background.forEach(([n])=>{n.inert=true;});
     toggle.focus({preventScroll:true});
    }
    if(next&&opened&&nextPanel!==active){
     if(nextPanel===panels[0]||panels.indexOf(nextPanel)<panels.indexOf(active)){
      header.querySelector(`[aria-controls="${active.id}"]`)?.focus({preventScroll:true});
     }else requestAnimationFrame(()=>{if(opened&&active===nextPanel)nextPanel.querySelector('[data-action="close-panel"]')?.focus({preventScroll:true});});
    }
    if(!next&&opened){
     background.forEach(([n,prior])=>{n.inert=prior;});background=[];
     menu.querySelectorAll('[data-action="open-panel"]').forEach(b=>b.setAttribute('aria-expanded','false'));
     if(document.activeElement===toggle||menu.contains(document.activeElement)){
      (desktop.matches?header.querySelector('.header__desktop-nav-toggle,.nav-bar__link'):toggle)?.focus({preventScroll:true});
     }
    }
    opened=next;active=nextPanel||panels[0];position();
   }
   const observer=new MutationObserver(sync);
   observer.observe(menu,{attributes:true,attributeFilter:['aria-hidden']});
   panels.forEach(p=>observer.observe(p,{attributes:true,attributeFilter:['class']}));
   function keydown(event){
    if(!opened)return;
    if(event.key==='Escape'){event.preventDefault();event.stopPropagation();toggle.click();return;}
    if(event.key==='Tab'){
     const candidates=[header.querySelector('.header__logo-link'),header.querySelector('.es-header-wishlist a'),header.querySelector('.header__cart-toggle'),toggle,...active.querySelectorAll('a[href],button,input,select,textarea,[tabindex]')].filter(n=>n&&!n.disabled&&n.tabIndex>=0&&visible(n));
     if(!candidates.length)return;
     const current=candidates.indexOf(document.activeElement);
     const nextIndex=(current+(event.shiftKey?-1:1)+candidates.length)%candidates.length;
     event.preventDefault();candidates[nextIndex].focus();
    }
   }
   const resize=()=>{if(desktop.matches&&opened)toggle.click();position();};
   const beforeToggle=event=>{
    if(opened&&event.target.closest('.swym-wishlist,.header__cart-toggle'))toggle.click();
    if(event.target.closest('.header__mobile-nav-toggle')&&!opened&&header.querySelector('.header__search-bar-wrapper.is-visible')){
     header.querySelector('[data-action="toggle-search"]')?.click();
    }
   };
   header.addEventListener('click',beforeToggle,true);
   document.addEventListener('keydown',keydown);
   window.addEventListener('resize',resize,{passive:true});
   const size=new ResizeObserver(position);size.observe(header.querySelector('.header'));
   states.set(header,()=>{searchCleanup();observer.disconnect();size.disconnect();header.removeEventListener('click',beforeToggle,true);document.removeEventListener('keydown',keydown);window.removeEventListener('resize',resize);background.forEach(([n,prior])=>{n.inert=prior;});if(opened)document.documentElement.classList.remove('is-locked');});
   sync();
  });
 }
 initialize(document);
 document.addEventListener('shopify:section:load',e=>initialize(e.target));
 document.addEventListener('shopify:section:unload',e=>e.target.querySelectorAll('[data-es-header]').forEach(h=>{states.get(h)?.();states.delete(h);}));
})();
